module.exports = __webpack_public_path__ + "727666a986583ab9bc282e5064eb9ed1.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/Users/VK.png
 ** module id = 284
 ** module chunks = 0
 **/